'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlotFunnelIcon = function PlotFunnelIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 32.2 29.5' }, props),
        _react2.default.createElement('path', { d: 'M3.1 3.2h26v5.1h-26zM7.6 9.7h17.3v5.1H7.6zM9.6 16.1h13.3v5H9.6zM12 22.6h8.5v3.9H12z' })
    );
};

exports.default = PlotFunnelIcon;